<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <LoadingComponent :loading="loading" :message="loadingMessage" style="z-index: 1000;"></LoadingComponent>

    <v-container class="toolbar__container">
      <v-form ref="form" v-model="formValidado">
        <v-row>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker
              :label="$t('delayByGeofence.startDate')"
              v-model="dti"
              :time-picker-props="timeProps"
              :text-field-props="textFieldProps"
              :date-picker-props="dtiProps"
              time-format="HH:mm:ss"
              date-format="dd/MM/yyyy"
              :clear-text="$t('datetime.close')"
            >
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker
              :label="$t('speedReport.endDate')"
              v-model="dtf"
              :time-picker-props="timeProps"
              :text-field-props="textFieldProps"
              :date-picker-props="dtfProps"
              time-format="HH:mm:ss"
              date-format="dd/MM/yyyy"
              :clear-text="$t('datetime.close')"
            >
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-autocomplete
              v-model="idEquipamentoSelected"
              :items="equipamentos"
              item-text="nome_equipamento"
              item-value="id_equipamento"
              clearable
              :label="$t('equipmentChecklist.equipment')"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  @click="populaRelatorio"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-tabs v-model="tab" style="margin-top: 20px;">
      <v-tab>{{ $t('equipmentChecklist.aggregated') }}</v-tab>
      <v-tab>{{ $t('equipmentChecklist.detailed') }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <!-- Aggregated View -->
      <v-tab-item>
        <merus-data-table
          :headers="headersAgregado"
          :items="dadosAgregados"
          :loading="loadingtable"
          :default-multi-sort="defaultSort"
          :loading-text="$t('system.messages.loading')"
        

 cod-tabela="RELCHECKLISTSEQUIPAMENTOSFUNCIONARIO__DETALHADO" @update:headers="headersAgregado = $event">
          <template v-slot:toolbar>
            <CadastroToolbar
              :title="$t('equipmentChecklist.reportTitle')"
              :token="token"
              :items="dadosAgregados"
              csv-title="checklistsfuncionarioagregado"
              :pdf-title="$t('equipmentChecklist.reportTitle')"
              :pdf-headers="headersAgregado"
              pdf-filename="checklistsfuncionarioagregado"
              hide-search
            />
          </template>
        </merus-data-table>
      </v-tab-item>

      <!-- Detailed View -->
      <v-tab-item>
        <merus-data-table
          :headers="headersDetalhado"
          :items="dadosDetalhados"
          :loading="loadingtable"
          :default-multi-sort="defaultSort"
          :loading-text="$t('system.messages.loading')"
        

 cod-tabela="RELCHECKLISTSEQUIPAMENTOSFUNCIONARIO__DETALHADO" @update:headers="headersDetalhado = $event">
          <template v-slot:toolbar>
            <CadastroToolbar
              :title="$t('equipmentChecklist.reportTitleDetailed')"
              :token="token"
              :items="dadosDetalhados"
              csv-title="checklistsfuncionariodetalhado"
              :pdf-title="$t('equipmentChecklist.reportTitleDetailed')"
              :pdf-headers="headersDetalhado"
              pdf-filename="checklistsfuncionariodetalhado"
              hide-search
            />
          </template>
        </merus-data-table>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import LoadingComponent from '../LoadingComponent.vue';
import MerusDataTable from "../Tables/MerusDataTable.vue";
import CadastroToolbar from "../Toolbars/CadastroToolbar.vue";
import EventBus from "@/utils/eventBus";
import DateUtils from "@/utils/dateutils";

export default {
  components: {
    LoadingComponent,
    MerusDataTable,
    CadastroToolbar
  },
  data: () => ({
    headersDetalhado: [],
    headersAgregado: [],
    user: null,
    token: null,
    loading: false,
    loadingMessage: "",
    loadingtable: false,
    formValidado: false,
    tab: 0,
    dti: null,
    dtf: null,
    idEquipamentoSelected: null,
    equipamentos: [],
    dadosAgregados: [],
    dadosDetalhados: [],
    config: null,
    timeProps: {
      useSeconds: true,
    }
  }),
  computed: {
    defaultSort() {
      return [
        { value: 'total_checklists', options: { text: this.$t('routs.decreasing'), value: -1 } }];
    },
    dtiProps() {
      return {
        max: this.yesterday
      }
    },
    dtfProps() {
      let min = null;
      if (this.dti) {
        if (typeof this.dti === 'string') {
          min = `${this.dti.substring(6,10)}-${this.dti.substring(3,5)}-${this.dti.substring(0,2)}`;
        } else {
          min = this.dti.toISOString().substring(0,10);
        }
      }
      return {
        min: min
      }
    },
    textFieldProps() {
      return {
        prependIcon: "mdi-calendar"
      }
    },
    yesterday() {
      let td = new Date();
      td.setDate(td.getDate() - 1);
      return td.toISOString().substring(0,10);
    }
  },
  watch: {},
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
  },
  methods: {

    initialize() {
      this.getConfig();
      this.populaEquipamentos();
    },
    getConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          this.config = response.data[0];
          [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(this.config.hora_inicial_dia_operacao);
        },
      });
    },
    populaEquipamentos() {
      apiController.request(apiController.endpoints.getallEquipamentos, {
        onSuccess: (response) => {
          this.equipamentos = response.data || [];
        },
      });
    },
    formatDateForAPI(date) {
      if (!date) return null;
      let dateObj;
      
      // Convert to Date object first
      if (typeof date === 'string') {
        // Handle string format like "2024-01-15T10:30:00" or "15/01/2024 10:30:00"
        if (date.includes('T')) {
          // ISO format - remove timezone info and parse
          dateObj = new Date(date.replace('Z', '').substring(0, 19));
        } else if (date.includes('/')) {
          // Convert from DD/MM/YYYY HH:mm:ss to Date object
          const parts = date.split(' ');
          const datePart = parts[0].split('/');
          const timePart = (parts[1] || '00:00:00').split(':');
          dateObj = new Date(
            parseInt(datePart[2]), // year
            parseInt(datePart[1]) - 1, // month (0-indexed)
            parseInt(datePart[0]), // day
            parseInt(timePart[0] || 0), // hours
            parseInt(timePart[1] || 0), // minutes
            parseInt(timePart[2] || 0)  // seconds
          );
        } else {
          // Try to parse as-is
          dateObj = new Date(date);
        }
      } else if (date instanceof Date) {
        dateObj = date;
      } else {
        console.warn('Unexpected date format:', date);
        return null;
      }

      // Validate date
      if (isNaN(dateObj.getTime())) {
        console.warn('Invalid date:', date);
        return null;
      }

      // Format as YYYY-MM-DD HH:mm:ss (MySQL datetime format)
      // Use local time components to avoid timezone conversion issues
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      const hours = String(dateObj.getHours()).padStart(2, '0');
      const minutes = String(dateObj.getMinutes()).padStart(2, '0');
      const seconds = String(dateObj.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    populaRelatorio() {
      if (!this.dti || !this.dtf) {
        EventBus.$emit('show-alert', {
          mensagem: this.$t('validation.dateRangeRequired'),
          tipo: 'warning'
        });
        return;
      }

      this.loadingtable = true;
      this.dadosAgregados = [];
      this.dadosDetalhados = [];

      const startDate = this.formatDateForAPI(this.dti);
      const endDate = this.formatDateForAPI(this.dtf);
      const idEquipamento = this.idEquipamentoSelected;

      console.log('Loading aggregated data:', { startDate, endDate, idEquipamento });

      // Load aggregated data
      apiController.request(apiController.endpoints.getChecklistsequipamentorespostasagregadasporfuncionario, {
        params: { dti: startDate, dtf: endDate, idEquipamento },
        onSuccess: (response) => {
          console.log('Aggregated data received:', response.data);

          // Check if response contains error
          if (response.data && response.data.erro) {
            console.error('API returned error:', response.data.mensagem);
            this.loadingtable = false;
            EventBus.$emit('show-alert', {
              mensagem: response.data.mensagem || this.$t('system.messages.error'),
              tipo: 'error'
            });
            return;
          }

          const recordCount = Array.isArray(response.data) ? response.data.length : 0;
          console.log('Aggregated data count:', recordCount, 'records');
          this.dadosAgregados = Array.isArray(response.data) ? response.data : [];
          this.loadDetailedData(startDate, endDate, idEquipamento);
        },
        onError: (e) => {
          console.error('Error loading aggregated data:', e);
          this.loadingtable = false;
        },
      });
    },
    loadDetailedData(startDate, endDate, idEquipamento) {
      console.log('Loading detailed data:', { startDate, endDate, idEquipamento });

      // Load detailed data using existing endpoint
      apiController.request(apiController.endpoints.getChecklistsequipamentorespostaspordata, {
        params: { dti: startDate, dtf: endDate },
        onSuccess: (response) => {
          console.log('Detailed data received:', response.data);
          
          // Check if response contains error
          if (response.data && response.data.erro) {
            console.error('API returned error:', response.data.mensagem);
            this.loadingtable = false;
            EventBus.$emit('show-alert', {
              mensagem: response.data.mensagem || this.$t('system.messages.error'),
              tipo: 'error'
            });
            return;
          }
          
          let dados = Array.isArray(response.data) ? response.data : [];
          console.log('Initial detailed data count:', dados.length, 'records');
          
          // Filter by equipment if selected
          if (idEquipamento) {
            const beforeFilter = dados.length;
            dados = dados.filter(d => d.id_equipamento == idEquipamento);
            console.log(`Filtered by equipment ${idEquipamento}: ${beforeFilter} -> ${dados.length} records`);
          }
          
          // Show all records - include those with and without users
          // Map records to ensure all fields are present, using user name when available
          dados = dados.map(d => ({
            ...d,
            nome_checklist: d.nome_checklist || 'N/A',
            nome_usuario: d.nome_usuario || 'Sem Usuário',
            id_usuario: d.id_usuario_alteracao || 0
          }));
          
          console.log(`Mapped detailed data count: ${dados.length} records`);
          
          console.log('Final detailed data count:', dados.length);
          this.dadosDetalhados = dados;
          this.loadingtable = false;
        },
        onError: (e) => {
          console.error('Error loading detailed data:', e);
          this.loadingtable = false;
        },
      });
    }
  }
};
</script>

<style scoped>
.toolbar__container {
  height: fit-content;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 5px 5px grey;
  padding: 20px 15px 20px 15px;
  margin-bottom: 20px;
}
</style>

